import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/top-bar/top-bar.js';
      import {BreadcrumbClickEvent, BreadcrumbItem} from '@oicl/openbridge-webcomponents/dist/components/breadcrumb/breadcrumb.js';
import {ObcTopBarMenuButtonIcon} from '@oicl/openbridge-webcomponents/dist/components/top-bar/top-bar.js';

      export interface Props {
     appTitle?: string;
     pageName?: string;
     menuButtonIcon?: ObcTopBarMenuButtonIcon;
     menuButtonActivated?: boolean;
     dimmingButtonActivated?: boolean;
     appsButtonActivated?: boolean;
     leftMoreButtonActivated?: boolean;
     userButtonActivated?: boolean;
     userButtonDisabled?: boolean;
     tall?: boolean;
     wideMenuButton?: boolean;
     showAppsButton?: boolean;
     showDimmingButton?: boolean;
     showUserButton?: boolean;
     showClock?: boolean;
     showDate?: boolean;
     showAppIcon?: boolean;
     inactive?: boolean;
     appButtonBreakpointPx?: number;
     dimmingButtonBreakpointPx?: number;
     appTitleBreakpointPx?: number;
     userButtonBreakpointPx?: number;
     appIconBreakpointPx?: number;
     settings?: boolean;
     breadcrumbItems?: BreadcrumbItem[]
   }

      
  
      export type {BreadcrumbClickEvent, BreadcrumbItem} from '@oicl/openbridge-webcomponents/dist/components/breadcrumb/breadcrumb.js';
export type {ObcTopBarMenuButtonIcon} from '@oicl/openbridge-webcomponents/dist/components/top-bar/top-bar.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcTopBar',
  props: {
    appTitle: {},
    pageName: {},
    menuButtonIcon: {},
    menuButtonActivated: { type: Boolean },
    dimmingButtonActivated: { type: Boolean },
    appsButtonActivated: { type: Boolean },
    leftMoreButtonActivated: { type: Boolean },
    userButtonActivated: { type: Boolean },
    userButtonDisabled: { type: Boolean },
    tall: { type: Boolean },
    wideMenuButton: { type: Boolean },
    showAppsButton: { type: Boolean },
    showDimmingButton: { type: Boolean },
    showUserButton: { type: Boolean },
    showClock: { type: Boolean },
    showDate: { type: Boolean },
    showAppIcon: { type: Boolean },
    inactive: { type: Boolean },
    appButtonBreakpointPx: {},
    dimmingButtonBreakpointPx: {},
    appTitleBreakpointPx: {},
    userButtonBreakpointPx: {},
    appIconBreakpointPx: {},
    settings: { type: Boolean },
    breadcrumbItems: {}
  },
  emits: ["menu-button-clicked", "dimming-button-clicked", "apps-button-clicked", "left-more-button-clicked", "user-button-clicked", "close", "back", "emergency-brightness-start", "emergency-brightness-stop", "breadcrumb-click"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onMenuButtonClicked: (event: CustomEvent<unknown>) => emit('menu-button-clicked', event as CustomEvent<unknown>),
onDimmingButtonClicked: (event: CustomEvent<unknown>) => emit('dimming-button-clicked', event as CustomEvent<unknown>),
onAppsButtonClicked: (event: CustomEvent<unknown>) => emit('apps-button-clicked', event as CustomEvent<unknown>),
onLeftMoreButtonClicked: (event: CustomEvent<unknown>) => emit('left-more-button-clicked', event as CustomEvent<unknown>),
onUserButtonClicked: (event: CustomEvent<unknown>) => emit('user-button-clicked', event as CustomEvent<unknown>),
onClose: (event: CustomEvent<unknown>) => emit('close', event as CustomEvent<unknown>),
onBack: (event: CustomEvent<unknown>) => emit('back', event as CustomEvent<unknown>),
onEmergencyBrightnessStart: (event: CustomEvent<unknown>) => emit('emergency-brightness-start', event as CustomEvent<unknown>),
onEmergencyBrightnessStop: (event: CustomEvent<unknown>) => emit('emergency-brightness-stop', event as CustomEvent<unknown>),
onBreadcrumbClick: (event: BreadcrumbClickEvent) => emit('breadcrumb-click', event as BreadcrumbClickEvent)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-top-bar',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})